import Link from '@mui/material/Link';
import { createLink } from '@tanstack/react-router';

export const RouterLink = createLink(Link);
